import { render, staticRenderFns } from "./Prelim-22.vue?vue&type=template&id=b19ae13c&scoped=true&"
import script from "./Prelim-22.vue?vue&type=script&lang=js&"
export * from "./Prelim-22.vue?vue&type=script&lang=js&"
import style0 from "./Prelim-22.vue?vue&type=style&index=0&id=b19ae13c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19ae13c",
  null
  
)

export default component.exports